import React from "react";

const SaveSuccessModal = ({ isOpen, theme = "light", language = "en", message = null }) => {
  if (!isOpen) return null;

  const isRTL = language === "ar";
  
  // Default message if none provided
  const displayMessage = message || (language === "ar" ? "تم الحفظ" : "Saved");

  return (
    <>
      <style>{`
        @keyframes ccFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes ccSlideUp {
          from { transform: translateY(32px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes checkmark-stroke {
          100% {
            stroke-dashoffset: 0;
          }
        }
        @keyframes checkmark-scale {
          0%, 100% {
            transform: none;
          }
          50% {
            transform: scale3d(1.15, 1.15, 1);
          }
        }
        @keyframes checkmark-fill {
          100% {
            box-shadow: inset 0px 0px 0px 40px ${
              theme === "dark" ? "rgba(52, 211, 153, 0.15)" : "rgba(16, 185, 129, 0.1)"
            };
          }
        }
      `}</style>

      <div
        style={{
          position: "fixed",
          inset: 0,
          background: theme === "dark" ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.35)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 11000,
          animation: "ccFadeIn 0.25s ease-out",
          overflow: "hidden",
          overscrollBehavior: "contain",
          willChange: "backdrop-filter",
        }}
      >
        <div
          style={{
            background: theme === "dark" ? "#1e293b" : "#ffffff",
            border: `1px solid ${
              theme === "dark" ? "rgba(148, 163, 184, 0.15)" : "rgba(226, 232, 240, 0.8)"
            }`,
            padding: "40px 60px",
            borderRadius: "28px",
            boxShadow:
              theme === "dark"
                ? "0 25px 50px -12px rgba(0, 0, 0, 0.5)"
                : "0 25px 50px -12px rgba(0, 0, 0, 0.12)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            minWidth: "220px",
            animation: "ccSlideUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
          }}
        >
          {/* Drawing Checkmark SVG */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
            style={{
              width: "72px",
              height: "72px",
              borderRadius: "50%",
              display: "block",
              strokeWidth: "4.5",
              stroke: theme === "dark" ? "#34d399" : "#10b981",
              strokeMiterlimit: "10",
              fill: "none",
              animation:
                "checkmark-scale 0.35s ease-in-out 0s both, checkmark-fill 0.4s ease-in-out 0.4s forwards",
            }}
          >
            <circle
              cx="26"
              cy="26"
              r="23.5"
              style={{
                strokeDasharray: "166",
                strokeDashoffset: "166",
                strokeWidth: "4.5",
                strokeMiterlimit: "10",
                stroke: theme === "dark" ? "#34d399" : "#10b981",
                fill: "none",
                animation: "checkmark-stroke 0.65s cubic-bezier(0.65, 0, 0.45, 1) forwards",
              }}
            />
            <path
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
              style={{
                transformOrigin: "50% 50%",
                strokeDasharray: "48",
                strokeDashoffset: "48",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                animation:
                  "checkmark-stroke 0.35s cubic-bezier(0.65, 0, 0.45, 1) 0.55s forwards",
              }}
            />
          </svg>

          {/* Success Text */}
          <span
            style={{
              fontSize: "19px",
              fontWeight: "750",
              color: theme === "dark" ? "#f1f5f9" : "#0f172a",
              letterSpacing: isRTL ? "0" : "0.5px",
              textAlign: "center",
            }}
          >
            {displayMessage}
          </span>
        </div>
      </div>
    </>
  );
};

export default SaveSuccessModal;
